export default __webpack_public_path__ + "static/sleep-ec00cdccb670cc6be63f532e46098328.png";